import { Container, StyledH4 } from '../styled';

type Props = {
    header?: string;
    body: string;
};

export const MessageView = ({ header, body }: Props) => {
    return (
        <Container>
            {header && <StyledH4>{header}</StyledH4>}
            <p>{body}</p>
        </Container>
    );
};
